import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {UserService} from '../services/user.service';

@Directive({
    selector: '[appRole]'
})
export class RoleDirective {
    private hasView = false;

    constructor(private userService: UserService,
                private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef) {
    }

    @Input() set appRole(roles: String[]) {
        if (roles.indexOf(this.userService.getLoggedUser().role.name) >= 0) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }

}


// WEBPACK FOOTER //
// /app/src/directives/role.directive.ts